import { Component, computed, effect, inject, Signal, signal, WritableSignal } from '@angular/core';
import { ButtonDirective, ButtonIcon, ButtonLabel } from 'primeng/button';
import { Bootstrap } from '@synegen/utility';
import { NgClass } from '@angular/common';

@Component({
  selector: 'ems-banner',
  imports: [ButtonDirective, ButtonLabel, ButtonIcon, NgClass],
  templateUrl: './banner.html',
  styleUrl: './banner.scss'
})
export class Banner {
  #bootstrap: Bootstrap = inject(Bootstrap);

  banner: Signal<BannerMessage> = computed(() => {
    const banner = <BannerMessage>this.#bootstrap.get('banner');
    return banner?.content ? banner : null;
  });

}

export type BannerMessage = {
  content: string,
  cta: string,
  ctaIcon: string,
  link: string
} | null;
